import { useState } from "react";
import { Copy, Check, Linkedin, MapPin, Mail } from "lucide-react";
import { Reveal } from "./Reveal";
import { ChapterLabel } from "./ChapterLabel";
import { profile, contact } from "../data/content";

export default function Contact() {
  const [copied, setCopied] = useState(false);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(profile.email);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.location.href = `mailto:${profile.email}`;
    }
  };

  return (
    <section id="contact" className="section-shell border-b-0" data-testid="contact-section">
      <div className="container-x">
        <ChapterLabel index="05" title="Contact" />

        <Reveal>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-ink">
            {contact.heading}
          </h2>
        </Reveal>
        <Reveal delay={0.08}>
          <p className="mt-6 max-w-2xl text-lg text-body leading-relaxed">{contact.line}</p>
        </Reveal>

        <Reveal delay={0.14}>
          <div className="mt-12 grid sm:grid-cols-3 gap-px bg-hairline border border-hairline max-w-4xl">
            <div className="bg-canvas p-7">
              <Mail size={18} className="text-teal mb-4" />
              <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-faint mb-2">Email</p>
              <button
                data-testid="contact-email-copy"
                onClick={copyEmail}
                className="text-sm text-ink link-underline inline-flex items-center gap-2 break-all text-left"
              >
                {profile.email}
                {copied ? <Check size={14} className="text-teal shrink-0" /> : <Copy size={14} className="text-faint shrink-0" />}
              </button>
              {copied && <span className="block text-xs text-teal mt-2" data-testid="contact-copied-note">Copied</span>}
            </div>
            <a
              data-testid="contact-linkedin-link"
              href={profile.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-canvas p-7 hover:bg-panel transition-colors duration-300 group"
            >
              <Linkedin size={18} className="text-teal mb-4" />
              <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-faint mb-2">LinkedIn</p>
              <span className="text-sm text-ink link-underline">linkedin.com/in/ritumali</span>
            </a>
            <div className="bg-canvas p-7">
              <MapPin size={18} className="text-teal mb-4" />
              <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-faint mb-2">Location</p>
              <span className="text-sm text-ink" data-testid="contact-location">{profile.location}</span>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <p className="mt-12 font-display text-lg text-faint italic">{contact.closing}</p>
        </Reveal>
      </div>
    </section>
  );
}
